'use strict';

var _ = require('lodash');
var progress = require('./progress');
var validator = require('./validator');
var tealium = require('../../../int_tealium/cartridge/js/tealium/tealium');

var util = {
    /**
     * @function
     * @description appends the parameter with the given name and value to the given url and returns the changed url
     * @param {String} url the url to which the parameter will be added
     * @param {String} name the name of the parameter
     * @param {String} value the value of the parameter
     */
    appendParamToURL: function (url, name, value) {
        // quit if the param already exists
        if (url.indexOf(name + '=') !== -1) {
            return url;
        }
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        return url + separator + name + '=' + encodeURIComponent(value);
    },

    /**
     * @function
     * @description remove the parameter and its value from the given url and returns the changed url
     * @param {String} url the url from which the parameter will be removed
     * @param {String} name the name of parameter that will be removed from url
     */
    removeParamFromURL: function (url, name) {
        if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
            return url;
        }
        var hash;
        var params;
        var domain = url.split('?')[0];
        var paramUrl = url.split('?')[1];
        var newParams = [];
        // if there is a hash at the end, store the hash
        if (paramUrl.indexOf('#') > -1) {
            hash = paramUrl.split('#')[1] || '';
            paramUrl = paramUrl.split('#')[0];
        }
        params = paramUrl.split('&');
        for (var i = 0; i < params.length; i++) {
            // put back param to newParams array if it is not the one to be removed
            if (params[i].split('=')[0] !== name) {
                newParams.push(params[i]);
            }
        }
        return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
    },

    /**
     * @function
     * @description appends the parameters to the given url and returns the changed url
     * @param {String} url the url to which the parameters will be added
     * @param {Object} params
     */
    appendParamsToUrl: function (url, params) {
        var _url = url;
        _.each(params, function (value, name) {
            _url = this.appendParamToURL(_url, name, value);
        }.bind(this));
        return _url;
    },
    /**
     * @function
     * @description extract the query string from URL
     * @param {String} url the url to extra query string from
     **/
    getQueryString: function (url) {
        var qs;
        if (!_.isString(url)) { return; }
        var a = document.createElement('a');
        a.href = url;
        if (a.search) {
            qs = a.search.substr(1); // remove the leading ?
        }
        return qs;
    },
    /**
     * @function
     * @description
     * @param {String}
     * @param {String}
     */
    elementInViewport: function (el, offsetToTop) {
        var top = el.offsetTop,
            left = el.offsetLeft,
            width = el.offsetWidth,
            height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        if (typeof(offsetToTop) !== 'undefined') {
            top -= offsetToTop;
        }

        if (window.pageXOffset !== null) {
            return (
                top < (window.pageYOffset + window.innerHeight) &&
                left < (window.pageXOffset + window.innerWidth) &&
                (top + height) > window.pageYOffset &&
                (left + width) > window.pageXOffset
            );
        }

        if (document.compatMode === 'CSS1Compat') {
            return (
                top < (window.document.documentElement.scrollTop + window.document.documentElement.clientHeight) &&
                left < (window.document.documentElement.scrollLeft + window.document.documentElement.clientWidth) &&
                (top + height) > window.document.documentElement.scrollTop &&
                (left + width) > window.document.documentElement.scrollLeft
            );
        }
    },

    /**
     * @function
     * @description Appends the parameter 'format=ajax' to a given path
     * @param {String} path the relative path
     */
    ajaxUrl: function (path) {
        return this.appendParamToURL(path, 'format', 'ajax');
    },

    /**
     * @function
     * @description
     * @param {String} url
     */
    toAbsoluteUrl: function (url) {
        if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
            url = '/' + url;
        }
        return url;
    },
    /**
     * @function
     * @description Loads css dynamically from given urls
     * @param {Array} urls Array of urls from which css will be dynamically loaded.
     */
    loadDynamicCss: function (urls) {
        var i, len = urls.length;
        for (i = 0; i < len; i++) {
            this.loadedCssFiles.push(this.loadCssFile(urls[i]));
        }
    },

    /**
     * @function
     * @description Loads css file dynamically from given url
     * @param {String} url The url from which css file will be dynamically loaded.
     */
    loadCssFile: function (url) {
        return $('<link/>').appendTo($('head')).attr({
            type: 'text/css',
            rel: 'stylesheet'
        }).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
    },
    // array to keep track of the dynamically loaded CSS files
    loadedCssFiles: [],

    /**
     * @function
     * @description Removes all css files which were dynamically loaded
     */
    clearDynamicCss: function () {
        var i = this.loadedCssFiles.length;
        while (0 > i--) {
            $(this.loadedCssFiles[i]).remove();
        }
        this.loadedCssFiles = [];
    },
    /**
     * @function
     * @description Extracts all parameters from a given query string into an object
     * @param {String} qs The query string from which the parameters will be extracted
     */
    getQueryStringParams: function (qs) {
        if (!qs || qs.length === 0) { return {}; }
        var params = {},
            unescapedQS = decodeURIComponent(qs);
        // Use the String::replace method to iterate over each
        // name-value pair in the string.
        unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
            function ($0, $1, $2, $3) {
                params[$1] = $3;
            }
        );
        return params;
    },

    /**
     * @function getQueryStringHashParams
     * @description Extracts all hash parameters from a queryString
     * @param {String} qs The query string from which the parameters will be extracted
     * @returns {Object} Returns an object representing the query parameters found in the hash
     */
    getQueryStringHashParams: function (qs) {

        // Exit early if an invalid string or a string with no hash is passed in
        if (!qs || qs.length === 0 || qs.indexOf('#') === -1) { return {}; }

        // Initialize local variables
        var params;     // Defaults the parameter object to store hash-params
        var qsArray;    // Represents the raw / source queryString

        // First, split the queryString on the hash
        qsArray = qs.split('#');

        // Next, get the queryString parameters for the hash key-value pairs
        params = util.getQueryStringParams(qsArray[1]);

        // Return the parameters
        return params;

    },

    fillAddressFields: function (address, $form) {
        for (var field in address) {
        	if (field === 'ID' || field === 'nickName'){
        		$form.find('[name$="addressid"]').val(address[field]).trigger("blur");
        		$form.find('[name$="addressid"]').closest(".form-row").addClass("show-text");
        	}
            if (field === 'ID' || field === 'UUID' || field === 'key') {
                continue;
            }

            // if the key in address object ends with 'Code', remove that suffix
            // keys that ends with 'Code' are postalCode, stateCode and countryCode
            $form.find('[name$="' + field.replace('Code', '') + '"]').val(address[field]);
            $form.find('[name$="' + field.replace('Code', '') + '"]').trigger("blur");
            $form.find('[name$="' + field.replace('Code', '') + '"]').closest(".form-row").addClass("show-text");
            // update the state fields
            if (field === 'countryCode') {
                $form.find('[name$="country"]').trigger('change');
                $form.find('[name$="country"]').closest(".form-row").addClass("show-text");
                // retrigger state selection after country has changed
                // this results in duplication of the state code, but is a necessary evil
                // for now because sometimes countryCode comes after stateCode
                $form.find('[name$="state"]').val(address.stateCode).trigger('change');
                $form.find('[name$="state"]').closest(".form-row").addClass("show-text");
            }
            util.updateInputFields();
        }
        /* Below commented to fix PXSFCC-5275 and same code is moved to updateselect() method */
        /*if ($('.selected-details').length > 0 && address != null) {
        	var address2 = '';
        	if ( address.address2 != null && address.address2 != '' ) {
        		address2 = address.address2+', ';
        	}
        	$('.selected-details').text(address.firstName+' '+ address.lastName+' | '+address.address1+', '+address2+address.city+' '+address.stateCode+' '+address.postalCode+' | USA');
        }*/
    },
    /**
     * @function
     * @description Updates the number of the remaining character
     * based on the character limit in a text area
     */
    limitCharacters: function () {
        $('form').find('textarea[data-character-limit]').each(function () {
            var characterLimit = $(this).data('character-limit');
            var charCountHtml = '<span class="char-remain-count">' + characterLimit + '</span>'
                              + '<span class="char-count-text"> ' + Resources.CHAR_LIMIT_MSG + '</span>';
            var charCountContainer = $(this).next('div.char-count');
            if (charCountContainer.length === 0) {
                charCountContainer = $('<div class="char-count"/>').insertAfter($(this));
            }
            charCountContainer.html(charCountHtml);
            // trigger the keydown event so that any existing character data is calculated
            $(this).change();
        });
    },
    /**
     * @function
     * @description Binds the onclick-event to a delete button on a given container,
     * which opens a confirmation box with a given message
     * @param {String} container The name of element to which the function will be bind
     * @param {String} message The message the will be shown upon a click
     */
    setDeleteConfirmation: function (container, message) {
        $(container).on('click', '.delete', function () {
            return window.confirm(message);
        });
    },
    /**
     * @function
     * @description Scrolls a browser window to a given x point
     * @param {String} The x coordinate
     */
    scrollBrowser: function (xLocation) {
        $('html, body').animate({scrollTop: xLocation}, 500);
    },

    isMobile: function () {
        var mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
        var    idx = 0;
        var isMobile = false;
        var userAgent = (navigator.userAgent).toLowerCase();

        while (mobileAgentHash[idx] && !isMobile) {
            isMobile = (userAgent.indexOf(mobileAgentHash[idx]) >= 0);
            idx++;
        }
        return isMobile;
    },

    isIOS: function(){
        return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPad',
          'iPhone',
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      },
      isIE: function() {
        const ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
        const msie = ua.indexOf('MSIE '); // IE 10 or older
        const trident = ua.indexOf('Trident/'); //IE 11
    
        return (msie > 0 || trident > 0);
    },


    selectbox: function() {
        this.updateselect();
        util.updateInputFields();
        $(document).off('click', '.selected-option').on('click', '.selected-option', function(e) {  
        	if($(e.target).hasClass("selected-option") && (!$(document.activeElement).hasClass('custom-select') || ($(document.activeElement).hasClass('custom-select') && $(document.activeElement).attr("tabindex")))){
                window.enableSortByFlyoutCheck = false;                       
                var $h = 0;
                var $this = $(this);
                var $variationObj = $this.closest('.product-variation-content');
                var variantNumber = 0;
                if ($this.siblings('select').is(':disabled')) {
                    return false;
                }
                if ( $variationObj.find('.variant-dropdown').length > 0 && $('.ui-dialog').hasClass('quick-view') && ($variationObj.closest('.product-col-2').hasClass('giftcard-detail') || $variationObj.closest('.product-col-2').hasClass('e-giftcard-detail')) ) {
                    variantNumber = 3;
                    $this.siblings('.selection-list').css('bottom', $this.outerHeight());
                } else {
                    variantNumber = 10;
                    $this.siblings('.selection-list').css('top', $this.outerHeight());
                }
                $('.custom-select').not($this.closest('.custom-select')).removeClass('current_item');
                if($(window).width() < 768 && $('body').hasClass('single-column-refinement') && !$('.refinements .filters').hasClass('refinement-mobile') && !$this.closest('.custom-select').hasClass('current_item')) {
                    $('.filters').hide();                
                }  

                $this.closest('.custom-select').toggleClass('current_item');
                        
                if ($(this).siblings('.input-select').val() == '') {
                    $this.closest('.field-wrapper').siblings('label').removeClass('input-focus');
                } else {
                    $this.closest('.field-wrapper').siblings('label:not(".input-focus")').addClass('input-focus');
                }
                
                $('.refinements .filters').removeClass('refinement-mobile'); 
                
                if($(this).closest('.sort-by').hasClass('current_item') && $('.sort-by').length > 0 && $(window).width() < 767) {
                    var $fixedHeader = $('.fixed-header').outerHeight();
                    $('html, body').animate({
                        'scrollTop' : $(this).closest('.sort-by').offset().top - $fixedHeader
                    }, 500, function(){
                        $('html, body').addClass('sort-overlay');
                        $('.refinements').addClass("js-fixed-bar");
                        if($(window).width() < 768 && $('body').hasClass('single-column-refinement')) {
                            var refTopPos = $('.fixed-header-wrapper').height() + 10;
                            if($('.nanobar-sticky').length>0){
                                refTopPos += $('.nanobar-sticky').height();
                            }
                            $('.refinements').attr('style', 'top:'+ refTopPos +'px !important');
                            $('.filters').hide();
                        }
                        setTimeout(function(){
                            window.enableSortByFlyoutCheck = true;
                        }, 505);
                    });
                } else if(!$(this).closest('.sort-by').hasClass('current_item') && $('.sort-by').length > 0) {
                    $('html, body').removeClass('sort-overlay');
                    if($(window).width() < 768 && $('body').hasClass('single-column-refinement')) {
                        if(!$('#header').hasClass('header_fixed')){
                            $('.refinements').removeClass("js-fixed-bar");                    
                            $('.refinements').removeAttr('style');                        
                        }else{
                            $('.refinements').removeAttr('style');
                        }      
                        $('.filters').show();
                    }
                }
                if ($this.siblings('.selection-list').find('li').length > variantNumber) {
                    $.each($this.siblings('.selection-list').find('li:visible').slice(0, variantNumber), function() {
                        $h += $(this).outerHeight();
                        $h -= 1;
                        $this.siblings('.selection-list').height($h);
                    });
                } else {
                    $this.siblings('.selection-list').height('auto');
                }
                if ( $variationObj.find('.variant-dropdown').length > 0 ) {
                    if( $variationObj.closest('.product-col-2').hasClass('giftcard-detail') ) {
                        $variationObj.find('.variant-dropdown').addClass('option-top');
                    }
                    if ($('.ui-dialog.quick-view').is(':visible')) {
                        util.loadSrollForQVProduct();
                    }
                }
            }
        }).off('click', '.selection-list li').on('click', '.selection-list li', function() {
            var $item = $(this).closest('.custom-select');
            var $form = $item.closest('form');
            $item.find('li').removeClass('selected');
            if( $(this).index() == 0 ){
            	$(this).closest(".form-row").removeClass("error-handle");
            }
            $(this).addClass('selected');
            $item.find('select option').eq($(this).index()).prop('selected', true);
            $item.find('.selected-option').text($(this).text());
            $item.removeClass('current_item');
            $item.find('select').trigger('change');
            $item.find('select').trigger('blur');
            $('html, body').removeClass('sort-overlay');
            if ($(this).closest('.field-wrapper').find('.input-select').val() == '') {
            	$(this).closest('.field-wrapper').siblings('label').removeClass('input-focus');
            } else {
            	$(this).closest('.field-wrapper').siblings('label:not(".input-focus")').addClass('input-focus');
            }
            if( $item.closest(".form-row").hasClass("type") ){
            	var $formRowList;
            	$formRowList = $form.find(".billingfields .form-row").not(".type, .creditcardnumber, .save-cancel, .makeDefault, .saveCard, .differedBilling");
            	if($formRowList.length == 0) {
            		$formRowList = $form.find(".payment-fields .form-row").not(".type, .creditcardnumber, .save-cancel, .makeDefault");
            	}
                if ($('.billingfields .differed-billing input').is(':checked')) {
            		$('.billingfields .differed-billing input').trigger('click');
         	    }
            	var formPrepare = require('./pages/checkout/formPrepare');
            	if($('.ui-dialog:visible').length == 0) {
	            	formPrepare.init({
	                    formSelector: 'form[id$="billing"]',
	                    continueSelector: '[name$="billing_save"],[name$="submit_form"],[name$="_billing_saveAddress"]'
	                });
            	}
            }
        }).on('change input', 'select', function(e) {
            var $element = $(this).closest('.form-row');
            var monthServerError = $('.billingfields .left-cont .month').find('span').hasClass('server-error');
            var profileMonthServerError = $('.paymentslist #CreditCardForm .month').find('span').hasClass('server-error');
            if(($element).hasClass('year') && (monthServerError || profileMonthServerError)){
                var currentyear=$('.selected-year').val();
                var selectedyear=$('.year ul.selection-list li.selected').text();
                if($('.selected-year').length > 0 && currentyear!== selectedyear && currentyear < selectedyear && $.isNumeric(selectedyear)){
                    $('.billingfields, .paymentslist .payment-fields').find('.month').removeClass('error-handle');
                    $('.billingfields, .paymentslist .payment-fields').find('.month span.server-error').remove();	
                }	
            } 
            util.updateselect();

            //Triggering blur on select. Since updateselect will work for custom select
            if(util.isMobile()) {
            	$(this).trigger('blur');
            }
            var $mac = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;
            if ($(window).width() > 1023){
                if((util.isIE() || $mac) && window.lastClickOrKey == 'key'){
                    $(this).trigger('blur');
                        setTimeout(()=>{
                            $('.focus-outline').removeClass('focus-outline');
                            $(this).focus().closest('.custom-select').addClass('focus-outline');
                        },500);
                }
            }
        });

        $('html').on('click', function(e) {
            if (!$('.custom-select.current_item').is(e.target) && !$('.custom-select.current_item').find('*').is(e.target)) {
                $('.custom-select.current_item select').trigger('blur');
            	if($(e.target).hasClass("dropdown-overlay")) {
            		$('.sort-by').removeClass('current_item');
            		$('body').removeClass('disable-scroll');
        	    } else {
        	    	$('.custom-select').removeClass('current_item');
        	    }
                $('html, body').removeClass('sort-overlay');
            } else if( $(e.target).is(".selected-option") ) {
        		$(e.target).next(".selection-list").find("li:hover").trigger("click");
        	}
        });

        $('body').off('keydown').on('keydown', function(e) {
            var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0,
                $activeselect = $('.custom-select.current_item');
            if ($activeselect.length > 0 && !util.isMobile()) {
            	$activeselect.find('select').focus();
            	$activeselect.addClass('current_item');
                var $list = $activeselect.find('li'),
                    $active;

                if (!$activeselect.find('li.selected').length) {
                    $activeselect
                        .find('li')
                        .eq($activeselect.find('option:selected').index())
                        .addClass('selected');
                }

                if (key === 8) { // Delete key
                    window.$currentkeycode = window.$currentkeycode.slice(0, -1);
                } else {
                    window.$currentkeycode += $.trim(String.fromCharCode(key).toLowerCase());
                }
                $active = $activeselect.find('li[label^="' + window.$currentkeycode + '"]');

                if ($active.length == 0) {
                    window.$currentkeycode = window.$currentkeycode.substr(window.$currentkeycode.length - 1, 1);
                    $active = $activeselect.find('li[label^="' + window.$currentkeycode + '"]');
                }
                if(key === 13 && ($('.custom-select').hasClass('current_item'))) {
                    $('.current_item').find(".selection-list .selected").trigger('click');
	            }
                if (key === 13 || key === 9 || key === 27 || key === 32) {
                    $active.eq(0).trigger('click');
                    var $mac = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;
                    if ($mac){
                    	$('.custom-select').find('select').css({'left':'0px'});
                    } else {
                    	$('.custom-select').find('select').css({'left':'-9999px'});
                    }
                } else if ($active.length != 0) {
                    $list.removeClass('hover');
                    $active.eq(0).addClass('hover');
                }
                if (key === 8) { // Delete key
                    return false;
                }                
                var $focused = $active,
                    $firstElPos = $activeselect.find('li:visible:first');
                //posTop = 0;

                if ($focused.length && $firstElPos.length) {
                    //var posTop = $focused.position().top - $firstElPos.position().top;
                }
            }
        })
    },
    updateselect: function() {
        $('.custom-select').each(function() {
            var $this = $(this);
            if ($this.find('.selected-option').length == 0) {
                $this.append('<div class="selected-option"></div>');
            }
            if ($this.find('.selection-list').length == 0) {
                $this.append('<ul class="selection-list"></ul>');
                var $list = '';
                if($this.hasClass("address-dropdown")) {
                	$this.find('option').each(function(i) {
                		if($(this).data("address") != undefined && $(this).data("isdefault") != undefined) {
                			var addressOption = $(this).data("address");
                			var isDefault = $(this).data("isdefault");
                			var address2 = '';
                        	if ( addressOption != undefined && addressOption.address2 != null && addressOption.address2 != '' ) {
                        		address2 = addressOption.address2+', ';
													}
										if(addressOption != undefined && addressOption != null && addressOption != ''){
												var address = '<span class="nickname-bold">'+ addressOption.nickName + " " + isDefault +'</span>'+' '+ addressOption.firstName +' '+ addressOption.lastName +' | '+ addressOption.address1 +', '+ address2 + addressOption.city +', '+ addressOption.stateCode +' '+ addressOption.postalCode +' | '+ addressOption.countryAbbr;
										}
                            $list += '<li label="' + $(this).text().toLocaleLowerCase() + '">' + address + '</li>';
                		} else {
        	                $list += '<li label="' + $(this).text().toLocaleLowerCase() + '">' + $(this).html() + '</li>';
                		}
                    });

                } else {
                	$this.find('option').each(function() {
    	                $list += '<li label="' + $(this).text().toLocaleLowerCase() + '">' + $(this).html() + '</li>';
    	            });
                }
                $this.find('.selection-list').append($list);
            } else {
                $this.find('.selection-list li').each(function() {
                    $this.attr('label', $.trim($(this).text().toLocaleLowerCase()));
                });
            }
            if($this.hasClass("address-dropdown")) {
            	var selectedOption = $(this).find('select option:selected');
            	var addressOption = $(selectedOption).data("address");
            	var isDefault = $(selectedOption).is("[data-isdefault]");
            	var isDefaultValue ='';
            	if(isDefault) {
            		isDefaultValue = $(selectedOption).data("isdefault");
            	}
            	var address2 = '';
            	if ( addressOption != undefined && addressOption.address2 != null && addressOption.address2 != '' ) {
            		address2 = addressOption.address2+', ';
            	}
            	if(addressOption != undefined ) {
	                var address = '<span class="nickname-bold">'+ addressOption.nickName + " " + isDefaultValue+'</span>'+' '+ addressOption.firstName +' '+ addressOption.lastName +' | '+ addressOption.address1 +', '+ address2 + addressOption.city +', '+ addressOption.stateCode +' '+ addressOption.postalCode +' | '+ addressOption.countryAbbr;
	                $this.find('.selected-option').html(address);
	                //PXSFCC-4751
	                var addrID = "<span class='address-id-mobile'><b>"+ addressOption.nickName +" "+ isDefaultValue +"</b></span>";
	                var addrName = "<span class='address-name-mobile'>"+ addressOption.firstName +" "+ addressOption.lastName +"</span>"
	                $(this).find('.address-nickname-mobile').html(addrID+" "+addrName);
            	} else {
            		$this.find('.selected-option').html($(this).find('select option:selected').text());
            		if($this.find('select option:selected').text() == "") {
            			$this.find('.selected-option').html($(this).find("select option[selected= 'selected']").text());
            		}
            		$this.find('.address-nickname-mobile').text($(this).find('select option:selected').text());
            	}
            	/* Below code has been added To fix PXSFCC-5275 */
            	 if ($this.closest(".field-wrapper").find('.selected-details').length > 0 && address != null) {
                 	var address2 = '';
                 	var address = addressOption;
                 	if ( address.address2 != null && address.address2 != '' ) {
                 		address2 = address.address2+', ';
                 	}
                 	$this.closest(".field-wrapper").find('.selected-details').text(address.firstName+' '+ address.lastName+' | '+address.address1+', '+address2+address.city+' '+address.stateCode+' '+address.postalCode+' | USA');
                 }
            } else {
            	if (!$this.find('select option').eq(0).hasClass('emptytext')) {
            		if($this.find('select').val() == "") {
                		$this.find('.selected-option').html("");
                		$this.closest('.form-row').addClass('optional');
                		if($this.closest('.form-row').not('.country').hasClass('show-text')) {
                			$this.closest('.form-row').not('.country').removeClass('show-text');
	                    }
                	} else {
                		$this.find('.selected-option').html($this.find('select option:selected').text());
                		$this.closest('.form-row').removeClass('optional');
                		if(!$this.closest('.form-row').not('.country').hasClass('show-text')) {
                			$this.closest('.form-row').not('.country').addClass('show-text');
	                    }
                		if($this.find('.selected-option').text() == "") {
                			$this.find('.selected-option').html($this.find('select').find("option[selected='selected']").text());
                			$this.find('select').val($this.find('select').find("option[selected='selected']").val());
                		}
                	}
            	} else {
            		$this.find('.selected-option').html($this.find('select option:selected').text());
            	}
            }
            if($('.savedAddressCount').length > 0 && $('.savedAddressCount').val() === '0'){
                $('.address-dropdown, .saved-address-count').hide();
            }

            $this.find('.selection-list li').removeClass('selected').eq($this.find('select option:selected').index()).addClass('selected');

            // Updated to ensure this applies to ALL selected items (CustomerService-ContactUs
            // needs this logic to exist in order to highlight default selections)
            if ($(this).find('select option:selected')) {
                $this.find('.selected-option').addClass('selected');
            } else {
                $this.find('.selected-option').removeClass('selected');
            }
            var $item = $(this).closest('.custom-select');
            var $form = $item.closest('form');
            if( $item.closest(".form-row").hasClass("type") ){
            	var $formRowList;
            	$formRowList = $form.find(".billingfields .form-row").not(".type, .creditcardnumber, .save-cancel, .makeDefault, .saveCard, .differedBilling");
            	if($formRowList.length == 0) {
            		$formRowList = $form.find(".payment-fields .form-row").not(".type, .creditcardnumber, .save-cancel, .makeDefault");
            	}
            	var formPrepare = require('./pages/checkout/formPrepare');
            	if($('.ui-dialog:visible').length == 0) {
            		if ($('#express-order-submit').length > 0) {
                     	formPrepare.init({
                             formSelector: 'form[id$="express-order-submit"]',
                             continueSelector: '[name$="submit"]'
                         });
                     } else {
    	            	formPrepare.init({
    	                    formSelector: 'form[id$="billing"]',
    	                    continueSelector: '[name$="billing_save"],[name$="submit_form"],[name$="_billing_saveAddress"]'
    	                });
                     }
            	}
            }
        });
    },
    giftMessageCharCount: function(){
    	$('.fields-address .input-textarea').closest('.field-wrapper').find('.character-count').remove();
        $('.fields-address .input-textarea').closest('.field-wrapper').prepend('<div class="character-count">(330 Characters left)</div>');
        if($('.input-textarea').val() != "" && $('.input-textarea').val() !== undefined) {
    		var updatedChar = $('.input-textarea').val().length,
    			maxChar = parseInt($('.input-textarea').attr('maxlength')),
    			char = maxChar - updatedChar;
    			$('.character-count').text('('+ char + ' Characters left)');
    	}
        $('.input-textarea').on('change keyup', function () {
        	var $this = $(this),
            	length = $this.val().length,
            	maxChar = parseInt($this.attr('maxlength')),
            	char;
            if (length >= maxChar) {
            	$this.val($this.val().slice(0, maxChar));
                $('.character-count').text(' ' + Resources.CHARACTER_LIMIT_REACHED);
            } else {
                char = maxChar - length;
                $('.character-count').text('('+ char + ' Characters left)');
            }
        });
    },
    addPersonalMessage: function(){
        $(document).on('click', '.personal-message input[type="checkbox"]', function(){
            if ($(this).is(':checked')){
                $(this).parents('.product-add-to-cart').find('.fields-address').addClass('active');
            } else {
                $(this).parents('.product-add-to-cart').find('.fields-address').removeClass('active');
                $(this).closest('.pdpForm').find('.please-select').text('');
            }
        });

        $(document).find('.personal-message').each(function(){
            var $check = $(this).find('input[type="checkbox"]');
            if ($check.is(':checked')){
                $(this).parents('.product-add-to-cart').find('.fields-address').addClass('active');
            } else {
                $(this).parents('.product-add-to-cart').find('.fields-address').removeClass('active');
                $(this).closest('.pdpForm').find('.please-select').text('');
            }
        });
    },
    questionAndAnwserEvent: function() {
        //Q&A
    	// We are adding this to fix iPhone issue. Q&A section of all content assets.
    	$(".qa-content a.question").attr({"href":"javascript:void(0);","aria-expanded":"false","role":"button"});
    	$('body').off('click', '.qa-section .qa-content a.question').on('click', '.qa-section .qa-content a.question', function(e) {
            e.preventDefault();
            var $curObj = $(this).closest(".qa-content");
            var $otherobjans = $('.qa-content').find('.answer');
            var $otherobjques = $('.qa-content').find('.question');
            var $othercontent = $('.qa-content');
            if ((!$curObj.find('.question').hasClass('active')) && (!$curObj.find('.answer').hasClass('active'))) {
            	$otherobjques.attr("aria-expanded","false");
            	$curObj.find('.question').attr("aria-expanded","true");
                $otherobjans.removeClass('active');
                $otherobjques.removeClass('active');
                $othercontent.removeClass('active');
                $curObj.find('.answer').addClass('active');
                $curObj.find('.question').addClass('active');
                $curObj.addClass('active');
            } else {
            	$curObj.find('.question').attr("aria-expanded","false");
                $curObj.find('.answer').removeClass('active');
                $curObj.find('.question').removeClass('active');
                $curObj.removeClass('active');
            }
        });        
    },
    // added as part of SC-5009
    plccCartBannerAccordianEvent: function() {
    	$('body').off('click', '.plcc-cart-banner-container .accordian-action-btn').on('click', '.plcc-cart-banner-container .accordian-action-btn', function(e) {
            e.preventDefault();
            $('.plcc-cart-banner-container').toggleClass('expanded');
        });
    },
    /**
     * @function
     * @description To show Q&A section based section the user is available in SPC
     * @param {String} currentSection The name of the section to show Q&A
     */
    showQuestionAndAnwser: function(currentSection) {
    	if(currentSection == 'checkout-login') {
    		$('.questions-answers .questions').removeClass("js-show").addClass("js-hide");
    		$('.questions.'+currentSection).removeClass("js-hide").addClass("js-show");
    	} else {
    		$('.questions.checkout-login').removeClass("js-show").addClass("js-hide");
        	$('.questions-answers').removeClass("js-hide").addClass("js-show");
        	$('.questions-answers .questions').removeClass("js-show").addClass("js-hide");
        	$('.questions-answers .questions.'+currentSection).removeClass("js-hide").addClass("js-show");
    	}
    },
    inputfocusEvent: function(){
        // input-focus
        $('body').off('focus','.field-wrapper input,.field-wrapper select, .field-wrapper textarea').on('focus','.field-wrapper input,.field-wrapper select, .field-wrapper textarea', function() {
            var $label = $(this).closest('.form-row').find('label');
            if($label.length && !$label.hasClass('input-focus')){
                $label.addClass('input-focus');
            }
        });

        $('body').off('blur','.field-wrapper input,.field-wrapper select, .field-wrapper textarea').on('blur','.field-wrapper input,.field-wrapper select, .field-wrapper textarea', function() {
            var $label = $(this).closest('.form-row').find('label');
            if (!$(this).val().length && $label.hasClass('input-focus')){
                $label.removeClass('input-focus');
            }
        });
    },
    updateInputFields : function() {
    	 $("body").find(".form-row.show-text").find("label").addClass("input-focus");
    },
    adjustForAutofill : function() {
        $('.make-label-absolute .form-row').each(function(e,i){
            var $self = $(this);
            var $input = $self.find('select').length ? $self.find('select') : ( $self.find('input').length ? $self.find('input') : $self.find('textarea') );
            var $inputLabel = $self.find('label');
            if( ($input.val() && $input.val().length) && !$inputLabel.hasClass('input-focus') ){
                $inputLabel.addClass('input-focus');
            }
        });
    },
    createAccount: function(){
        if ($(window).width() >= 767){
            $('.create-login').find('.col-2 .inner-block').hide();
            $('.create-login').find('.create-account').on('click', function(e) {
                e.preventDefault();
                $(this).closest('.col-2').find('.inner-block').slideDown();
                $('.create-inner-block').hide();
            });
        } else {
            var $createLogin = $('.create-login').find('.col-2 .inner-block');
            var $innerBlock = $createLogin.hide();
            if ($('.pt_account').length > 0) {
            	var $viewMore = $('.create-login').find('.login-box-content .view-more');
            	var $creataccount = $('.create-login').find('.login-box-content .create-account');

            	$($creataccount).on('click', function(e) {
                    e.preventDefault();
                    $(this).closest('.col-2').find('.view-more-hide').slideDown();
                    $(this).closest('.login-box').addClass('grey-login-box');
                    $($viewMore).hide();
                    $($creataccount).hide();
                    $('.login-create-account .login-box-content .benfits-content').hide();
                });

            } else {
            	var $viewMore = $('.create-login').find('.login-box-content .create-account, .login-box-content .view-more');
            }
            var registrationFormError = $('.create-login .col-2 .inner-block .view-more-hide #RegistrationForm').find('.form-row span').hasClass('server-error');
            if (registrationFormError) {
                $('.create-account').hide();
                $('.view-more').hide();
                $('.create-login').find('.col-2 .inner-block .view-more-hide').show();
                var $errorfield=$('.create-login .col-2 .inner-block .view-more-hide #RegistrationForm').find('.server-error').closest('.form-row').find('input');
                $errorfield.addClass('error-focus');
            } else {
                $('.create-login').find('.col-2 .view-more-hide').hide();
            }
            $('.create-login').find('.login-create .create-account').on('click', function(e) {
                e.preventDefault();
                $(this).closest('.col-2').find('.inner-block').slideDown();
                $('.create-inner-block').hide();
            });

            $($viewMore).on('click', function(e) {
                e.preventDefault();
                if ($('.pt_account').length > 0) {
                	if ($('.login-create-account .login-box-content .benfits-content').length <= 0) {
                		$('.login-create-account .login-box-content').append($('.benfits-content'));
                	}
                } else {
                	$(this).closest('.col-2').find('.view-more-hide').slideDown();
                    $(this).closest('.login-box').addClass('grey-login-box');
                }
                $($viewMore).hide();
            });
        }
    },
    passwordStatusValidation: function(){
    	
    	//Trigger handle focus element on  password field on load, Trigger handle for confirm password triggered inside password field
        $(window).load(function() {
            if($('#RegistrationForm').length>0){
            	if($('#RegistrationForm .password input').val() != ""){
        			$('#RegistrationForm .password input').triggerHandler('focus');
        		}
            }
            if($('#ChangePassowrdForm').length>0){
            	if($('#ChangePassowrdForm .newpassword  input').val() != ""){
        			$('#ChangePassowrdForm .newpassword  input').triggerHandler('focus');
        		}
            }
        });

        $('#RegistrationForm .password input,#ChangePassowrdForm .newpassword  input,#NewPasswordForm .password  input').on('input focus',function(){
        	if($(this).hasClass("currentpassword") && $(this).hasClass("password")){
        		$(this).removeClass("password");
        		$(this).closest('.form-row').removeClass("password");
        		$(this).closest('.form-row').addClass("currentpassword");
        	}
        	var value=($(this).val()).trim();
        	$(this).val(value);
        	var pwdCheckElements=$(this).closest('.form-row').next('.password-status');
        	var letters = /[a-z]/i;
    		var numbers= /\d/;
    		var islengthCheck= value.length>=8 ? true : false;
    		var isContainsNumber=numbers.test(value);			
    		var isContainsChar= letters.test(value);
    		function toggleClasses(elem,bool){
    			if(bool){
    				pwdCheckElements.find('.'+elem).removeClass('default');
    				pwdCheckElements.find('.'+elem).removeClass('fail');				
    				pwdCheckElements.find('.'+elem).addClass('success');
    			}else{				
    				if(!pwdCheckElements.find('.'+elem).hasClass('fail')){
    					pwdCheckElements.find('.'+elem).removeClass('success');
    					pwdCheckElements.find('.'+elem).addClass('default');
    				}
    			}
    		}
    		
    		toggleClasses('length-check',islengthCheck); 			
    		toggleClasses('number-check',isContainsNumber);
    		toggleClasses('letter-check',isContainsChar);
    		if(islengthCheck && isContainsNumber && isContainsChar){
    			$(this).closest('.form-row').find('.form-caption').hide();
    			pwdCheckElements.show();
    			$(this).data('validation-counter','0');
    		}
    		
    		//Trigger focus element on confirm password field 
    		if($(this).closest('.form-row').siblings('.newpasswordconfirm').length>0){
    			$(this).closest('.form-row').siblings('.newpasswordconfirm').find('input').triggerHandler('focus');
    		}
    		if($(this).closest('.form-row').siblings('.passwordconfirm').length>0){
    			$(this).closest('.form-row').siblings('.passwordconfirm').find('input').triggerHandler('focus');
    		}
        });
        
        $('#RegistrationForm .passwordconfirm input,#ChangePassowrdForm .newpasswordconfirm input,#NewPasswordForm .passwordconfirm input').on('input focus',function(){
        	var password = $(this).closest('form').find('input.password').not('.currentpassword');
        	var pwdCheckElements=$(this).closest('.form-row').next('.password-status');
        	if((password.val()).trim() == ($(this).val()).trim()){
        		if(password.val()==""){
        			pwdCheckElements.find('.match-check').removeClass('success');
    				pwdCheckElements.find('.match-check').removeClass('fail');				
    				pwdCheckElements.find('.match-check').addClass('default');
        		}else{
        			pwdCheckElements.find('.match-check').removeClass('default');
    				pwdCheckElements.find('.match-check').removeClass('fail');				
    				pwdCheckElements.find('.match-check').addClass('success');
    				pwdCheckElements.find('.match-check').attr({"id":"pwd-match"});              
        		}				
            }else{
                if(!pwdCheckElements.find('.match-check').hasClass('fail')){
                    pwdCheckElements.find('.match-check').removeClass('success');
                    pwdCheckElements.find('.match-check').addClass('default');
    				pwdCheckElements.find('.match-check').removeAttr("id");                    
                }
        	}
        	$(this).val($(this).val().trim());
        });
    },
    swapDiv: function(){
        if ($(window).width() <= 767){
            $('.create-login').find('.col-2:parent').each(function () {
                $(this).insertBefore($(this).closest('.create-login').find('.search-wishlist'));
            });
            var $errorfield=$('.create-login .col-2 .inner-block .view-more-hide #RegistrationForm').find('.server-error').closest('.form-row').find('input');
                 if($errorfield.length > 0 && !($errorfield).is(':focus')){
                        $('html, body').animate({
                            scrollTop: $errorfield.offset().top - $('.col-1 .inner-block .login-box').offset().top -  250
                        }, 100);                      
                        $errorfield.focus();
                    } 
            } 
    },
    sendGiftMessageCharCount: function(){
    	$('.sendtofriend .form-row.message').find('.input-textarea').closest('.field-wrapper').prepend('<div class="character-count">0/256</div>');
     	$('.sendtofriend .form-row.message').find('.input-textarea').on('change keyup', function () {
     		var $this = $(this),
     			length = $this.val().length,
     			maxChar = parseInt($this.attr('maxlength')),
     			char;
     		if (length >= maxChar) {
     			$this.val($this.val().slice(0, maxChar));
     			$('.character-count').text(' ' + Resources.CHARACTER_LIMIT_REACHED);
     		} else {
     			char = maxChar - length;
     			$('.character-count').text( char + '/256');
     		}
     	});
     },
     updateValue: function() {
    	 if($(window).width() <= 767){
	    	 $('.secondary-navigation .update-value').on('click', function(e){
	 			e.preventDefault();
	 			$(this).toggleClass('value-updated');
	 			$(this).closest('.secondary-navigation').find('.secondary-navigation-links').toggleClass('active');
	 			$(this).closest('#secondary').toggleClass('overlay');
	 		});
    	 }
     },
     copyClipboard: function() {
    	 var clipboard = new Clipboard('.copy-link');

    	 clipboard.on('success', function(e) {
    	     console.info('Action:', e.action);
    	     console.info('Text:', e.text);
    	     console.info('Trigger:', e.trigger);
    	     $(e.trigger).addClass('copied-link').text(Resources.COUPON_CODE_COPIED);

    	     e.clearSelection();
    	 });

    	 clipboard.on('error', function(e) {
    	     console.error('Action:', e.action);
    	     console.error('Trigger:', e.trigger);
    	 });
     },
     creditLimit: function() {
    	 var creditLimit = 0;
    	 if($(".header-promo-bottom", ".footer-plcc").length > 0 ){
    		 creditLimit = $(".header-promo-bottom", ".footer-plcc").data("creditlimit");
    	 }
    	 $(".header-promo-bottom-creditlimit").text(creditLimit);
     },
    getCookie: function(name) {
        var value = '; ' + document.cookie,
            parts = value.split('; ' + name + '=');
        if (parts.length == 2) {
            return parts.pop().split(';').shift();
        }
        return '';
    },
    createCookie: function(name,value,days){
        var expires = '',
            $days = !days ? 1/24 : parseInt(days);
        if ($days) {
            var date = new Date();
            date.setTime(date.getTime()+($days*24*60*60*1000));
            expires = '; expires='+date.toUTCString();
            document.cookie = name+'='+value+expires+'; path=/;secure';
        }

    },
    removeCookie: function(name) {
        var expires = '';
        this.createCookie(name,-1,-1);
    },

    /**
     * @function
     * @description Returns the current width of the browser
     * @returns {Number} Pixel representation of the actual browser width
     */
    getViewPortWidth: function() {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    },

    /**
     * @function
     * @returns {Number} for inputfield
     */
    allowDigits: function(inputfield) {
    	if (inputfield.val() != undefined && inputfield.val() != null && inputfield.val() != '') {
    		inputfield.val(inputfield.val().replace(/\D/g, ''));
    	}
    },

    /**
     * @function
     * @description Derives the viewport for the current user based on the width
     * of the active display (focusing on 1024, 768, and 320px breakpoints)
     * @returns {Object} Pixel representation of the active viewport
     */
    getViewPort : function() {

        // Initialize local variables
        var currentWidth;   // Captures the current width of the viewPort

        // Determine the current width of the viewport
        currentWidth = util.getViewPortWidth();

        // Is this desktop?
        if (currentWidth > 1024) {
            return {'viewPort': 'desktop', 'width' : 1024};
        }

        // Is this tablet?
        if (currentWidth < 1024 && currentWidth >= 768) {
            return {'viewPort': 'tablet', 'width' : 768};
        }

        // Lastly, assume mobile
        return {'viewPort': 'mobile', 'width' : 768};

    },
    /**
     * @function
     * @description Funtion removes click event from links when user is on that page
     * @param {String} Parent div class name where links are
     */
    secondaryNavigationActiveInactiveStates : function( parentDiv ){
        $(document).ready(function() {
            var navLinks = $('.' + parentDiv + ' a');
            if(navLinks != null){
                navLinks.each(function () {
                    if($(this).attr('href') === window.location.href){
                        $(this).attr('style', 'cursor:text').click(function (event){
                            event.preventDefault();
                        });
                    }
                });
            };
	    });
    },
    veiwmorelesswithellipse : function(intitalcharacters){
    	// Configure/customize these variables.
        var showChar = intitalcharacters;  // How many characters are shown by default
        var ellipsestext = "...";
        var moretext = "View more";
        var lesstext = "View Less";
        $('.more').each(function() {
            var content = $(this).html();
            if(content.length > showChar) {
                var c = content.substr(0, showChar);
                var h = content.substr(showChar, content.length - showChar);
                var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span><div class="morelink">' + moretext + '</div></span>';
                $(this).html(html);
            }
        });

        $("body").off('click','.morelink').on('click', '.morelink',function() {
            if($(this).hasClass("less")) {
                $(this).removeClass("less");
                $(this).html(moretext);
            } else {
                $(this).addClass("less");
                $(this).html(lesstext);
            }
            $(this).parent().prev().toggle();
            $(this).prev().toggle();
            return false;
        });
    },

    /**
     * @function
     * @description Validate the user selected address in billing section for OLPS
     */
    validateForPLCCAddress : function(addressID) {
    	var url = util.appendParamsToUrl(Urls.validatePLCCBillingAddress, {AddressID: addressID, format: 'ajax'});
    	progress.show('#main');
    	$.getJSON(url, function (data) {
    		//refresh the billing section, with success response
            if (data.success) {
            	if ($('.spc-express-checkout').length > 0 ) {
            		$(".spc-express-checkout .express-billing-refresh[data-refreshurl]").trigger('click');
            	} else {
            		var cardSelected = true;
            		var actionUpdateURL = $('.checkout-tab-head.open').attr('data-refreshurl');
            		if ($('.billingfields.hide').length == 0) {
            			cardSelected = false;
            		}
            		actionUpdateURL = util.appendParamToURL(actionUpdateURL, 'cardSelected', cardSelected);
            		$('.billing-refresh').attr('data-refreshurl', actionUpdateURL);
            		$(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
            	}
            }

            var checkoutUtagURL=Urls.getCheckoutUtagData;
    	    $.ajax({ 
    	        url: checkoutUtagURL,
    	        method: 'GET',
    	        success: function(data) {
    	            if(data !== ''){
    	                utag_data=data.utagDL;
    	             } 
    	        }
    	    });
        });
	},

    paymentcardselection : function(currentselect){
        var $form = currentselect.closest('form');
    	var $formRowList;
    	$formRowList = $form.find(".billingfields .form-row").not(".type, .creditcardnumber, .save-cancel, .makeDefault, .saveCard, .differedBilling");
    	if($formRowList.length == 0) {
    		$formRowList = $form.find(".payment-fields .form-row").not(".type, .creditcardnumber, .save-cancel, .makeDefault");
    	}

    	if(currentselect.find('option:selected').attr('plccType') === 'true') {
    		$formRowList.addClass('hide');
    		$form.find(".billingfields,.payment-fields").find('label span.error').text("");
        	$formRowList.find("input,select").addClass("hide");
        	$form.find(".billingfields,.payment-fields").find('.cvv-label').addClass("hide");
        	$form.find(".billingfields,.payment-fields").find('.form-row.owner, .form-row.month, .form-row.year, .form-row.cvn').removeClass('error-handle required');
        	$form.find(".billingfields").find('.form-row.owner input,.form-row.month select,.form-row.year select, .form-row.cvn input').removeClass('error required');
        	$form.find('.form-row.creditcardnumber').find('.creditcardnumber ').attr('maxlength','16');
        	$form.find('.form-row.creditcardnumber').find('.creditcardnumber ').attr('minlength','8');
        	if($('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val()=="true" && !$('#is-PayPal').is(':checked')){
        		$('.couponsection').find('.couponcontent').addClass('deferactive');
        		if ($('.couponsection').find('.couponcontent').is(':visible')){
        			$('.couponsection').find('.couponcontent').css('display','flex');
        		}
        	}
        	
        	if($('.billingfields').length > 0 && $('.billingfields .differed-billing').length > 0) {
        		$('.billingfields .differed-billing').removeClass('hide');
					}
        	if ($('input[name="creditCardError"]').length && $('input[name="creditCardError"]').val() == 'true'){
        		$form.find('.form-row.creditcardnumber').find('.creditcardnumber').val('');
	    		$form.find('.form-row.cvn').find('.cvn').val('');
	    		$form.find('.form-row.creditcardnumber').find('label').removeClass('input-focus');
					$form.find('.form-row.cvn').find('label').removeClass('input-focus');
					$('input[name="creditCardError"]').val('false');
	    	}
        	if($('.billingfields .differed-billing').length > 0 && $('.billingfields .differed-billing').html() == '') {
        		$('.billingfields .differed-billing').html($('.card-list .differed-billing.selection').html());
        		if($('.billingfields .differed-billing').html() == '') {
        			$('.billingfields .differed-billing').html($('.card-list .differed-billing.selected').html());
        		}
        		$('.billingfields .differed-billing').removeClass('hide');
        	}
    	} else {
				$formRowList.removeClass("hide");
    		$form.find(".billingfields,.payment-fields").find('label span.error').text("");
				$formRowList.find("input,select").removeClass("hide");
				if($form.find(".billingfields,.payment-fields").find('.form-row.owner,.form-row.month,.form-row.year,.form-row.cvn').find('.required-indicator').length <= 0){
					$form.find(".billingfields,.payment-fields").find('.form-row.owner,.form-row.month,.form-row.year,.form-row.cvn').find('label').append('<span class="required-indicator"> * </span>');
				}
    		$form.find(".billingfields,.payment-fields").find('.cvv-label').removeClass("hide");
				$form.find(".billingfields,.payment-fields").find('.form-row.owner, .form-row.month, .form-row.year, .form-row.cvn').removeClass("error-handle").addClass('required');
				$form.find(".billingfields,.payment-fields").find('.form-row.owner input,.form-row.month select,.form-row.year select, .form-row.cvn input').removeClass("error").addClass('required');
    		$form.find('.form-row.creditcardnumber').find('.creditcardnumber').attr('maxlength','19');
    		$form.find('.form-row.creditcardnumber').find('.creditcardnumber ').attr('minlength','1');
    		if($('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val() =="true"){
        		$('.couponsection').find('.couponcontent').removeClass('deferactive');
        		$('.differed-billing-content').addClass('hide');
        		var $deferCheckbox= $('.differedBilling input[type="checkbox"]');
                $deferCheckbox.val(false);
        		$deferCheckbox.prop('checked',false);
        		if ($('.couponsection').find('.couponcontent').is(':visible')){
        			$('.couponsection').find('.couponcontent').css('display','block');
        		}
        	}

    		if ($('input[name="creditCardError"]').length && $('input[name="creditCardError"]').val() == 'true'){
	    		$form.find('.form-row.creditcardnumber').find('.creditcardnumber').val('');
	    		$form.find('.form-row.cvn').find('.cvn').val('');
	    		$form.find('.form-row.creditcardnumber').find('label').removeClass('input-focus');
					$form.find('.form-row.cvn').find('label').removeClass('input-focus');
					$('input[name="creditCardError"]').val('false');

	    	}

    		if($('.billingfields').length > 0 && $('.billingfields .differed-billing').length > 0) {
    			$('.billingfields .differed-billing').addClass('hide');
    		}
    		if($('.billingfields .differed-billing').length > 0 && $('.billingfields .differed-billing').html() == '') {
        		$('.billingfields .differed-billing').html($('.card-list .differed-billing.selection').html());
        		if($('.billingfields .differed-billing').html() == '') {
        			$('.billingfields .differed-billing').html($('.card-list .differed-billing.selected').html());
        		}
        		$('.billingfields .differed-billing').addClass('hide');
        	}
    	}

    	//remove class since above code is clearing value
    	$('.form-row.creditcardnumber,.form-row.owner,.form-row.month,.form-row.year,.form-row.cvn').removeClass('show-text');
		if($('.form-row.month').find('.selection-list li').not(':first-child').hasClass('selected')){
			$('.form-row.month').addClass('show-text');
		}
		if($('.form-row.year').find('.selection-list li').not(':first-child').hasClass('selected')){
			$('.form-row.year').addClass('show-text');
		}
    	// removing validation for cvn on changing the card.
    	if($('.form-row.cvn').hasClass('error-handle')){
    		$('.form-row.cvn').removeClass('error-handle');
    		$('.form-row.cvn').find('label .server-error').remove();
    	}
    	if($('.form-row.creditcardnumber').hasClass('error-handle')){
    		$('.form-row.creditcardnumber').removeClass('error-handle');
    		$('.form-row.creditcardnumber').find('label .server-error').remove();
    	}
    	if($('.form-row.month').hasClass('error-handle')){
    		$('.form-row.month').removeClass('error-handle');
    		$('.form-row.month').find('label .server-error').remove();
    	}
    	if($('.form-row.year').hasClass('error-handle')){
    		$('.form-row.year').removeClass('error-handle');
    		$('.form-row.year').find('label .server-error').remove();
    	}
    },
    getCityStateOptions: function() {
    	var util = this;
    	$("body").off('change keyup','input[name$="_postal"]').on('change keyup','input[name$="_postal"]',function (e) {
    		var postalCodeValue = $(this).val();
    		if((postalCodeValue != null) && postalCodeValue.length > 4) {
    			var url = util.appendParamsToUrl(Urls.getCityStateOptions, {postalCode: postalCodeValue, format: 'ajax'});
    			var $form = $('[name$="_state"],[name$="_city"]').closest(".form-row");
        		$.getJSON(url, function (data) {
                    // Make sure data Object should not be empty
        			if (data && !$.isEmptyObject(data)) {
                        $('[name$="_city"]').val(data.cityStateOptions.split(',')[0]);
                        $('[name$="_state"]').val(data.cityStateOptions.split(',')[1]).trigger('change');
        				if (!$form.hasClass('error-handle')) {
        					$form.addClass("show-text");
        					$form.find('label').addClass("input-focus");
        				} else {
        					$form.removeClass('error-handle');
        					$form.find('label span.error').remove();
        					$form.addClass("show-text");
        					$form.find('label').addClass("input-focus");
        					$form.find('[class*="input-"]').removeClass('error');
        				}
        			}
        		});
    		}
    	});
    },
    dialogCloseFocus: function() {
    	/* PXSFCC-4495_WCAG_Modal_focus_management */
    	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
        	$(this).focus();
        });
        $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");

    },

    /**
     * @function renameElement
     * @description This function is used to replace self element with new tag
     * @param {JQuery} $element The JQuery selected element
     * @param {Function} newElement Replaced with new element
     */
    renameElement: function($element, newElement){
        for(var i=0; i<$element.length; i++){
            $($element[i]).wrap("<"+newElement+">");
            var $newElement = $($element[i]).parent();
            //Copying Attributes
            $.each($($element[i]).prop('attributes'), function(index) {
                $newElement.attr(this.name, this.value);
            });
            $($element[i]).contents().unwrap();
        }
    },

    /**
     * @private
     * @function
     * @description Adding slick slider for product recommendations
     *
     */
    pdpSlickSlider: function() {
        var parentSelector = arguments[0] ? arguments[0] : $('body');         
    	var $recommendations = parentSelector.find(".recommendation .recommendation-tiles"),
        	slideMaxSize = { desktop: $(".pt_cart_template_b").length ? 3 : 4, tablet: 3, mobile: 1.4 },
            toScroll = 1,
            screenResolution = {tablet : 1023 , mobile : 767};

        //if recommendation is horizontal, slide shows 5 products
        if (parentSelector.find(".you-may-like.recommendation").hasClass('recommendations-h')) {
            slideMaxSize.desktop = ($(".pt_cart_template_b").length && !$(".cart-empty").length)? 3 : 5;
        }
        
        if (parentSelector.find(".you-may-like.recommendation").hasClass('recommendations-h') && parentSelector.find("#carousel-recommendations").hasClass('einstien-reommendations')) {
            slideMaxSize.desktop = ($(".pt_cart_template_b").length && !$(".cart-empty").length) ? 3 : 4;
            slideMaxSize.tablet = $(".pt_cart_template_b").length ? 3 : 4;
        }
    	$recommendations.each(function() {
    		var $curRecommendation = $(this);
            let slickVertical;
            if ($curRecommendation.parents(".you-may-like.recommendation").hasClass('bh-recommendations') || $curRecommendation.parents(".you-may-like.recommendation").hasClass('recommendations-h')){
                slickVertical = false;
                
            } else if ($curRecommendation.parents(".you-may-like.recommendation").hasClass('recommendations-v')) {
                slickVertical = true;
            }
            
    		// If recommendation is already initialized,
    		// Unslick for slidesTotal to calculated correctly
    		if( $curRecommendation.hasClass("slick-initialized")){
    	    	$curRecommendation.slick("unslick");
    	    }

    		var	slidesTotal = $curRecommendation.children().length,
    			$tiles = $curRecommendation.find('.product-tile');

    	    slideMaxSize.desktop > slidesTotal ? slideMaxSize.desktop = slidesTotal : null;
    	    slideMaxSize.tablet > slidesTotal ? slideMaxSize.tablet = slidesTotal : null;
    	    slideMaxSize.mobile > slidesTotal ? slideMaxSize.mobile = slidesTotal : null;
    	    slidesTotal < slideMaxSize.desktop ? toScroll = 1 : toScroll = slideMaxSize.desktop;

    	    if ( $curRecommendation.length > 0 && $(window).width() > screenResolution.tablet ) {
    	    	$curRecommendation.find('.product-tile').addClass('product-height');
    	    }

    	    $tiles.syncHeight();
    	    if( $curRecommendation.hasClass("slick-initialized") ){
    	    	$curRecommendation.slick("unslick");
            }
            
            // wraps slick arrows with <li> tags after slick initialization. SC-7702
            $curRecommendation.on('init breakpoint', function(){
                if($curRecommendation.prop('nodeName') == 'UL'){
                    $($curRecommendation.children("button.slick-prev, button.slick-next")).wrap("<li></li>"); 
                    // WCAG replacing self element with new element tag which is already coming from JQuery plugin
                    util.renameElement($curRecommendation.find('li.inner-tile'),'div');                           
                }
                util.handleSlickArrowFunc($curRecommendation,screenResolution.mobile);
            });

    	    $curRecommendation.slick({
    	        slidesToShow: slideMaxSize.desktop,
    	        slidesToScroll: toScroll,
    	        dots: false,
    	        infinite: false,
                vertical: slickVertical,
                // here is set vertical to horizon
    	        verticalSwiping: false,

    	        responsive: [{
    	            breakpoint: screenResolution.tablet,
    	            settings: {
    	                slidesToShow: slideMaxSize.tablet,
    	                slidesToScroll: 3,
    	                arrows: true,
    	                vertical: false,
    	                swipe: true
    	            }
    	        }, {
    	            breakpoint: screenResolution.mobile,
    	            settings: {
    	                slidesToShow: slideMaxSize.mobile,
    	                slidesToScroll: 1,
    	                arrows: false,
    	                vertical: false,
    	                swipe: true
    	            }
    	        }]
            });
            
        });
    },
    /**
    * @private
    * @function
    * @description Adding slick slider for product recommendations for overlay
    *
    */
   addToCartSlickSlider: function() {
        var parentSelector = arguments[0] ? arguments[0] : $('body');         
    	var $recommendations = parentSelector.find(".cart-overlay .recommendation .recommendation-tiles"),
        	slideMaxSize = { desktop: 4, tablet: 3, mobile: 1.4 },
            toScroll = 1;
    
    	$recommendations.each(function() {
    		var $curRecommendation = $(this);
            let slickVertical;
            if ($curRecommendation.parents(".you-may-like.recommendation").hasClass('bh-recommendations') || $curRecommendation.parents(".you-may-like.recommendation").hasClass('recommendations-h') || ($curRecommendation.parents(".you-may-like.recommendation").length && $(window).width() > 1024 && $(window).width() < 1160)) {
                slickVertical = false;
                
            } else {
                slickVertical = true;
            }
    		// If recommendation is already initialized,
    		// Unslick for slidesTotal to calculated correctly
    		if( $curRecommendation.hasClass("slick-initialized") ){
    	    	$curRecommendation.slick("unslick");
    	    }

    		var	slidesTotal = $curRecommendation.children().length,
    			$tiles = $curRecommendation.find('.product-tile');

    	    slideMaxSize.desktop > slidesTotal ? slideMaxSize.desktop = slidesTotal : null;
    	    slideMaxSize.tablet > slidesTotal ? slideMaxSize.tablet = slidesTotal : null;
    	    slideMaxSize.mobile > slidesTotal ? slideMaxSize.mobile = slidesTotal : null;
    	    slidesTotal < slideMaxSize.desktop ? toScroll = 1 : toScroll = slideMaxSize.desktop;

    	    if ( $curRecommendation.length > 0 && $(window).width() > 1160 ) {
    	    	$curRecommendation.find('.product-tile').addClass('product-height');
    	    }

    	    if( $curRecommendation.hasClass("slick-initialized") ){
    	    	$curRecommendation.slick("unslick");
            }
            
            // wraps slick arrows with <li> tags after slick initialization. SC-7702
            $curRecommendation.on('init breakpoint', function(){
                if($curRecommendation.prop('nodeName') == 'UL'){
                    $($curRecommendation.children("button.slick-prev, button.slick-next")).wrap("<li></li>"); 
                    // WCAG replacing self element with new element tag which is already coming from JQuery plugin
                    util.renameElement($curRecommendation.find('li.inner-tile'),'div');                           
                }
            });

    	    $curRecommendation.slick({
    	        slidesToShow: slideMaxSize.desktop,
    	        slidesToScroll: toScroll,
    	        dots: false,
    	        infinite: false,
                vertical: slickVertical,
                // here is set vertical to horizon
    	        verticalSwiping: false,

    	        responsive: [{
    	            breakpoint: 1160,
    	            settings: {
    	                slidesToShow: slideMaxSize.tablet,
    	                slidesToScroll: 3,
    	                arrows: true,
    	                vertical: false,
    	                swipe: true
    	            }
    	        }, {
    	            breakpoint: 767,
    	            settings: {
    	                slidesToShow: slideMaxSize.mobile,
    	                slidesToScroll: 1,
    	                arrows: false,
    	                vertical: false,
    	                swipe: true
    	            }
    	        }]
            });
        });
   },
    /**
     * @private
     * @function
     * @description Adding slick slider for product set recommendations
     *
     */
    proset_SlickSlider: function() {
        var $recommendations = $(".special-recommendation .recommendation-tiles"),
            slideMaxSize = { desktop: 4, tablet: 3, mobile: 1.25 },
            toScroll = 1;

        $recommendations.each(function() {
            var $curRecommendation = $(this),
                slidesTotal = $curRecommendation.children().length,
                $tiles = $curRecommendation.find('.product-tile');

            slideMaxSize.desktop > slidesTotal ? slideMaxSize.desktop = slidesTotal : null;
            slideMaxSize.tablet > slidesTotal ? slideMaxSize.tablet = slidesTotal : null;
            slideMaxSize.mobile > slidesTotal ? slideMaxSize.mobile = slidesTotal : null;
            slidesTotal < 4 ? toScroll = 1 : toScroll = 4;

            if ( $curRecommendation.length > 0 && $(window).width() > 1024 ) {
                $curRecommendation.find('.product-tile').addClass('product-height');
            }
            $tiles.syncHeight();

            // wraps slick arrows with <li> tags after slick initialization. SC-7702
            $curRecommendation.on('init breakpoint', function(){
                if($curRecommendation.prop('nodeName') == 'UL')
                $($curRecommendation.children("button.slick-prev, button.slick-next")).wrap("<li></li>");
                util.handleSlickArrowFunc($curRecommendation,767);
            });

            $curRecommendation.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: false,
                infinite: false,
                verticalSwiping: false,
                vertical: false,
                rows: 1,

                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                        infinite: false,
                        swipe: true
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1.25,
                        slidesToScroll: 1,
                        arrows: false,
                        vertical: false,
                        infinite: false,
                        swipe: true
                    }
                }]
            });
        });
    },
    //new function for completeTheLook SlickSlider starts here
    completeTheLook_SlickSlider : function(){

        var $completeTheLook = $(".complete-the-look .productTiles");

        // wraps slick arrows with <li> tags after slick initialization. SC-7702
        $completeTheLook.on('init breakpoint', function(){
            if($completeTheLook.prop('nodeName') == 'UL')
            $($completeTheLook.children("button.slick-prev, button.slick-next")).wrap("<li></li>");
            util.handleSlickArrowFunc($completeTheLook,540);
        });
        
        $completeTheLook.slick({
            dots: false,
            infinite: false,
            slidesToShow:siteInfo.brandContextID=='bh' ? 4 : 5,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            
            responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                    infinite: false,
                    swipe: true
                }
            }, 
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    arrows: false,
                    vertical: false,
                    infinite: false,
                    swipe: true
                }
            }, 
            {
	            breakpoint: 1260,
	            settings: {
	            	slidesToShow:siteInfo.brandContextID=='bh' ? 4 : 5,
	                slidesToScroll: 1,
	                arrows: true,
	                vertical: false,
	                infinite: false,
	                swipe: true
	            }
        }]
        });
    },
    
    loadSrollForQVProduct: function () {
    	var $productVariant = $('.product-variation-content');
    	$productVariant.removeClass('max-height').removeAttr('style');
    	$productVariant.closest('.slimScrollDiv').height('auto');
    	$productVariant.closest('.slimScrollDiv').find('.slimScrollBar, .slimScrollRail').hide();
    	$productVariant.closest('.slimScrollDiv').find('.slimScrollBar').css('top', '0px');

    	if($productVariant.height() >= 466) {
    		if($productVariant.closest('.slimScrollDiv').length > 0){
    			$productVariant.closest('.slimScrollDiv').height('465px');
    			$productVariant.closest('.slimScrollDiv').find('.slimScrollBar,.slimScrollRail').show();
    		} else {
    			$productVariant.slimScroll({
    	        	height: '465px',
    	        	railVisible: true,
    	    		color: "#f4f4f4",
    	    		railColor: "#ffffff",
    	            railOpacity: 1,
    	            size: '10px',
    	            alwaysVisible: true
    	        });
    		}
    	} else {
    		$productVariant.addClass('max-height');
        }
    },
    productSetReadmore: function() {
    	// SM-5221
        $('.product-set-long-description').each(function() {
        	var totalHeightCountPrev = 0;
        	var $curObj = $(this);
        	var readHeight = $curObj.height();
        	$curObj.children().each(function() {
        		if($(this).is(':visible')){
	        		var $curChild = $(this);
		        	 	totalHeightCountPrev += $curChild.height();
		        	if (totalHeightCountPrev > readHeight ){
		        		$curChild.closest('.product-set-long-description').addClass('max-height-limit');
		        		return false;
		        	}
        		}
        	});
        });
	},
	deSerializeCreditCardForm: function(formdata,deferApplied) {
		// SM-7449: Prevent Credit Card Info From Being Cleared
		var i, keyValuePair, key, value, pairs,
			$creditCard = $('[data-method="CREDIT_CARD"]');
		// remove leading question mark if its there
		if (formdata.slice(0, 1) === '?') {
			formdata = formdata.slice(1);
		}
		if (formdata !== '') {
				pairs = formdata.split('&');
				for (i = 0; i < pairs.length; i += 1) {
						keyValuePair = pairs[i].split('=');
						key = decodeURIComponent(keyValuePair[0]);
						value = (keyValuePair.length > 1) ? decodeURIComponent(keyValuePair[1]) : undefined;
						// If key is that for a credit card, then enter the credit card details
						if(key.indexOf('creditCard') !== -1 && value){
							// As credit card number and cvn fields are dynamic, we would handle them seperately
							if(key.indexOf('number') !== -1 && value.indexOf('*') === -1){
								$creditCard.find('input[name*="_creditCard_number"]').val(value).trigger('change');
                                $creditCard.find('input[name*="_creditCard_number"]').closest('.form-row').find('label:not(".input-focus")').addClass('input-focus');
							} else if(key.indexOf('cvn') !== -1){
								$creditCard.find('input[name*="_cvn"]:visible').val(value).trigger('change');
                                $creditCard.find('input[name*="_cvn"]:visible').closest('.form-row').find('label:not(".input-focus")').addClass('input-focus');
							} else {
								$('#' + key).val(value.split('+').join(' ')).trigger('change');
                                $('#' + key).closest('.form-row').find('label:not(".input-focus")').addClass('input-focus');
							}                            
						}
				}
		}
		if(deferApplied !='' && deferApplied == true && $('#noPaymentNeeded').val() != "true"){
	        var $input = $('.deferCode').find('input');
	        var $checkbox= $('.differedBilling input[type="checkbox"]');
			$('.differed-billing-content').removeClass('hide');
			$input.val("");
			$input.closest('.form-row').find('label').removeClass('input-focus');
			$('.defercoupon').find('.value').html("PAYLATER");
			$checkbox.val(true);
			$checkbox.prop('checked',true);
			$('.defer-code-error').find('.empty-error').addClass('hide');
			$('.defer-code-error').find('.max-defer-error').addClass('hide');
			if(!$('.couponsection').find('.couponcontent').is(':visible')){
				$('.couponsection').find(' .row-header').trigger('click');
			}			
		}
    },

    /**
     * @function trapFocus
     * @description This function would move focus on focusable elements inside an element in a cyclical manner 
     * @param {JQuery} $focusContainer The jQuery set object of the element inside which focus is to be trapped
     * @param {Function} escapeCallback The function to be executed when escape key is pressed
     * @param {Boolean} addOutlineOnLoad Add focus outline ,Default-value:true
     */
    trapFocus: function($focusContainer, escapeCallback,addOutlineOnLoad){
        var focusableElementSelectors = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
        var focusLoopHandler, getLastFocusableElement, getFirstFocusableElement;

        addOutlineOnLoad = addOutlineOnLoad === false ? addOutlineOnLoad : true;

            getLastFocusableElement = function(){
               var focusableElements = $focusContainer.find(focusableElementSelectors).filter(':visible');
               return focusableElements[focusableElements.length - 1];
            }

            getFirstFocusableElement = function(){
                return $focusContainer.find(focusableElementSelectors).filter(':visible')[0];
            }
        
            focusLoopHandler = function(e) {
              if (e.keyCode === 9) {
                if (e.shiftKey && document.activeElement === getFirstFocusableElement()) {
                  e.preventDefault();
                  $(getLastFocusableElement()).focus().addClass('focus-outline');
                } else if (!e.shiftKey && document.activeElement === getLastFocusableElement()) {
                  e.preventDefault();
                  $(getFirstFocusableElement()).focus().addClass('focus-outline');
                }
              }
              else if(e.keyCode === 27){
                e.preventDefault();
                $focusContainer.removeAttr('tabindex');
                escapeCallback();
              }
            };
            $focusContainer.attr('tabindex','-1');
                        
            setTimeout(function(){
                $(getFirstFocusableElement()).focus();
                if(addOutlineOnLoad){  
                    $(getFirstFocusableElement()).addClass('focus-outline');
                }
            }, 0);
            $focusContainer.on('keydown', focusLoopHandler);
    },

    /**
     * @function pdpTabListNavigation
     * @description This function would move focus on tablist using keyboard arrow keys 
     **/
    pdpTabListNavigation:function() {
        $('.product-info [role=tablist]').on('keydown',function(e) {
            if (e.keyCode == 37 || e.keyCode == 38) {
                $(this).find(".focus-outline").closest('.tab').prev().find('button').focus().addClass('focus-outline');
                e.preventDefault();
            }
            if (e.keyCode == 39 || e.keyCode == 40) {
                $(this).find(".focus-outline").closest('.tab').next().find('button').focus().addClass('focus-outline');
                e.preventDefault();
            }
        });   
    },
    
    /**
     * @function
     * @description updates focus | WCAG login/Sign in validation on focus
     */
    checkoutGuestSignInFocus : function($chkoutGuestLoginForm){		    	    
		 	    $('body').off('keyup mousedown', '.checkout-tabs .checkoutlogin .guest-form .checkout-guest-btn button').on('keyup mousedown', '.checkout-tabs .checkoutlogin .guest-form .checkout-guest-btn button',function (ev) {
		 	        if((ev.keyCode && (ev.keyCode == 13)) || !ev.keyCode){
		 	            if (!$chkoutGuestLoginForm.valid()) {             	
		 	            	 $chkoutGuestLoginForm.find('.emailAddress input.email').addClass('focus-outline').focus();
		 	            	 if($chkoutGuestLoginForm.find('.emailAddress').find('label').find('span.error').text().indexOf('valid') > -1){
		 		   				  $chkoutGuestLoginForm.find('.username-checkout-guest').addClass('hide');
		 		   				  $chkoutGuestLoginForm.find('.emailValidCheckoutGuest').removeClass('hide');
		 		   			  }
		 		   			  else {
		 		   				  $chkoutGuestLoginForm.find('.emailValidCheckoutGuest').addClass('hide');
		 		   			  }
		 	             }                    
		 	         }   
		 	    });	 	  	  	
	},
	
	validateGuestEmailOnFocusOut : function($chkoutGuestLoginForm){
		 if (!$chkoutGuestLoginForm.valid()) { 
			  $chkoutGuestLoginForm.find('.username-checkout-guest').removeClass('hide');
			  if($chkoutGuestLoginForm.find('.emailAddress').find('label').find('span.error').text().indexOf('valid') > -1){
				  $chkoutGuestLoginForm.find('.username-checkout-guest').addClass('hide');
				  $chkoutGuestLoginForm.find('.emailValidCheckoutGuest').removeClass('hide');
			  }
			  else {
				  $chkoutGuestLoginForm.find('.emailValidCheckoutGuest').addClass('hide');
                  if($chkoutGuestLoginForm.find('.emailAddress').find("input-text.error").length === 0){
                    $chkoutGuestLoginForm.find('.username-checkout-guest').addClass('hide');
                  }
			  }
	       }    
	},
    	   
    validateLoginOnSubmit : function($form){
    	var $emailInput= $form.find('.form-row.username .input-text.email'),
    	$passwordInput= $form.find('.form-row.password .input-text.password');
    	 if (!$form.valid() || ($emailInput.hasClass('error') || $passwordInput.hasClass('error'))) { 
        	 if($emailInput.hasClass('error')){  
        		 setTimeout(function() { 
        		 $emailInput.addClass('focus-outline').focus().select();         		   	            		  
        		   if($emailInput.val().length > 0){
        			  $form.find('.usernameError').addClass('hide');
        			   $form.find('.errorInvalidEmail').removeClass('hide');        			   
        		   }
        		   else {
        			   $form.find('.errorInvalidEmail').addClass('hide');
        			   $form.find('.usernameError').removeClass('hide');
        		   }   
        		 }, 10);   
        	   }
             else { 
            	 setTimeout(function() { $passwordInput.addClass('focus-outline').focus(); }, 10); 
            } 
        }
    },
    
    validateEmailOnFocusOut : function($form){
    	var $emailInput= $form.find('.form-row.username .input-text.email'),
    	$passwordInput= $form.find('.form-row.password .input-text.password');
    	var formvalidator = $form.validate(validator.settings);
    	 if (!formvalidator.element($emailInput)) {
	        	if($emailInput.hasClass('error')){
         		   if($emailInput.val().length > 0){
         			   $form.find('.usernameError').addClass('hide');
         			   $form.find('.errorInvalidEmail').removeClass('hide');
                       $form.find('.usernameError').attr('id', 'email_error1_na');
         			   $form.find('.errorInvalidEmail').attr('id', 'email_error1');
         		   }
         		   else {
         			   $form.find('.usernameError').removeClass('hide');
         			   $form.find('.errorInvalidEmail').addClass('hide');
                       $form.find('.usernameError').attr('id', 'email_error1');
         			   $form.find('.errorInvalidEmail').attr('id', 'email_error1_na');

         		   }
	        	}
	        	if($form.find(".form-row.password").hasClass("error-handle")){
	        		$(".form-row.password").removeClass("error-handle");
	        		$passwordInput.removeClass("error");  
	        		$form.find('.passwordError').addClass('hide');  
	        	}
	        	if($passwordInput.val().length > 0){
	        		$form.find('.passwordError').addClass('hide');
	        	}
	     }
    },
    
    validatePasswordOnFocusOut : function($form){    	
    	var formValidatorPwd = $form.validate(validator.settings),
    	$emailInput= $form.find('.form-row.username .input-text.email'),
    	$passwordInput= $form.find('.form-row.password .input-text.password');
    	
    	if (!(formValidatorPwd.element($passwordInput))) {   
    			$form.find('.passwordError').show(); 
        }
    	else {
    		$form.find('.passwordError').hide();
    	}
    	
    	if (!formValidatorPwd.element($emailInput)) {
        	if($emailInput.hasClass('error')){
     		   if($emailInput.val().length > 0){
     			   $form.find('.usernameError').addClass('hide');
     			   $form.find('.errorInvalidEmail').removeClass('hide');
     		   }
     		   else {
     			   $form.find('.usernameError').removeClass('hide');
     			   $form.find('.errorInvalidEmail').addClass('hide');
     		   }
        	}
    	}
    },
    /**
    * @function 
    * @description Handle WCAG functionality of traversing using keyboard
    * @param {JQuery} $curRecommendation The jQuery set object of the slick container  
    * @param {Number} mobileBreakPoint Mobile Breakpoint value  
    */
    handleSlickArrowFunc: function($curRecommendation,mobileBreakPoint){
        var getFirstFocusableElement=$curRecommendation.find('.slick-slide').eq('0').find('.product-name-image-container .name-link'),
            getLastFocusableElement=$curRecommendation.find('.slick-slide').last().find('.product-name-image-container .name-link');
        
        $curRecommendation.on('afterChange', function(event, slick, currentSlide, nextSlide){
            if(window.lastClickOrKey === "key"){
                $(this).find('.slick-slide').eq(currentSlide).find('.product-name-image-container .name-link').trigger('focus').addClass('focus-outline');
            }             
        });

        $curRecommendation.on('keydown',function(e){
            if($(window).width() > mobileBreakPoint) return;

            if (e.keyCode === 9) {                        
                if (e.shiftKey) {                      
                    if(document.activeElement === getFirstFocusableElement[0]){
                        return;
                    }else{
                        e.preventDefault();
                        $curRecommendation.slick('slickPrev');
                    }
                }else if (!e.shiftKey) {                      
                    if(document.activeElement === getLastFocusableElement[0]){
                        return;
                    }else{
                        e.preventDefault();
                        $curRecommendation.slick('slickNext');
                    }
                }
            }
        });
    },
    newCardFlag : false,
    refreshBillingSection : false,
    selectedCard: ''

};

module.exports = util;